// eslint-disable-next-line
export const COMPANY_NAME = 'Compliance Consulting Operations GmbH';
